import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';
import { CacheService } from 'projects/common/src/app/services';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { environment } from 'src/environments/environment';
import { IChecklistExcel } from '../../../interfaces/checklistExcel';
import { IReportChecklist } from '../../../interfaces/report-checklist';
import { ReportChecklistService } from '../../../services/report-checklist.service';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'projects/authentication/src/app/services';

@Component({
  selector: 'app-checklist-modal',
  templateUrl: './checklist-modal.component.html',
  styleUrls: ['./checklist-modal.component.scss'],
})
export class ChecklistModalComponent implements OnInit, OnDestroy {
  @Input() public checkList: IReportChecklist;

  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;

  public logoutSub: Subscription;

  constructor(
    private activeModal: NgbActiveModal,
    private cacheService: CacheService,
    private reportChecklistService: ReportChecklistService,
    private _excelExportService: ExcelExportService,
    private authService: AuthenticationService,
  ) {
    this.disabledExcelBtn = false;
  }

  ngOnInit() {
    this.logoutSub = this.authService.tokenExpired$.subscribe(() => {
      this.activeModal.dismiss('logout');
    });
  }

  ngOnDestroy(): void {
    // Unsubscribe to avoid memory leaks
    if (this.logoutSub) {
      this.logoutSub.unsubscribe();
    }
  }

  public close(): void {
    this.activeModal.dismiss();
  }

  public download(): void {
    const format = `${environment.dateFormatSystem} ${environment.timeFormat}`;
    const date = moment(this.checkList.createAt, format).format(`${environment.dateFormatSystem}`);
    const params: IChecklistExcel = {
      checklistDate: this.checkList.createAt,
      sessionId: this.checkList.sessionId,
      operatorid: this.checkList.operatorid,
      machineId: this.checkList.machineid,
      checklistId: this.checkList.checklistId,
      companyId: this.cacheService.local('session').user.company.id,
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.reportChecklistService.GetChecklistReportDetailExcel(params).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'report-checklist', null, date, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
